import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import PropTypes from "prop-types";
import APPCONFIG from "constants/Config";
import ObjectOverride from "components/ObjectOverride";
import {Button} from "reactstrap";
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";

/**
 *  @property {Customers_Permits_Object} state
 *  @property {object} model
 *  @property {Customers_Permits_Properties} model.properties
 *  @property {Customers_Permits_Is} model.is
 *  @property {Customers_Permits_Has} model.has
 */
class CustomerNicsPermit extends ObjectOverride {
	static propTypes = {
		...super.PropTypes,
		permit: PropTypes.object,
	};

	constructor(props) {
		super(props, Types.Customers_Permits._name);
	}

	// noinspection JSUnusedGlobalSymbols
	loadSelf = async () => {
		let data = this.props.permit;
		if (this._ismounted && data) {
			this.model.properties.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			this.model.has.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			this.model.is.forEach((item, key) => {
				if (typeof item !== 'undefined' && item && typeof data[key] !== 'undefined') {
					this.setState({[key]: data[key]});
				}
			});
			await this.setState({
				"loading": false,
				"loaded": true
			});
			// noinspection JSPotentiallyInvalidUsageOfClassThis
			this.loadSelfAfter(data);
		}

		this.loadSelfAfterAlways();
	};


	removePermitImage = async (img_param) => {
		if(this.state[img_param].includes('permit')) {
			this.model.request = 'POST_IMAGE_REMOVE';
			if (img_param === 'image'){
				this.model.object.image = this.state.image;
				this.setState({ image: null });
				this.state.image = null;
				if (typeof (this.props.afterSave) === 'function') {
					this.props.afterSave(this.state);
				}
			} else {
				this.model.object.image_back = this.state.image_back;
				this.setState({ image_back: null });
				this.state.image_back = null;
				if (typeof (this.props.afterSave) === 'function') {
					this.props.afterSave(this.state);
				}
			}
			try {
				await this.model.submit(null, 'POST_IMAGE_REMOVE');
			} catch (e) {
				
			}
		} else {
			this.setState({[img_param]: ''})
		}
	}

	handleDeleteImage = (image) => {
		confirmAlert({
			title: 'Confirm Delete',
			message: typeof this.delete_message !== 'undefined' ? this.delete_message : 'Are you sure you want to remove this image?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						try {
							this.removePermitImage(image)
						} catch (error) {
						}
					}
				},
				{
					label: 'No',
					onClick: () => {
					}
				}
			]
		});
	}

	handleSubmit = async () => {
		//TODO: make this property not required. It looks like it is checking a string value of null which is causing an error for validating date format
		// since it is neither null nor a string in date format; but a string containing "null"
		if( !this.props.rootState.hasTwinCityPawnModule && (this.state.expiration === null || this.state.expiration === '') ) {
			this.state.expiration = "2099-12-31 23:59:59"
		}

		if( this.props.rootState.hasTwinCityPawnModule && (this.state.expiration === '' || this.state.expiration === null) ) {
			this.setState({expiration_error: "Permit Expiration is Required"})
		}
		else {
			await super.handleSubmit();
		}
	}

	form = () => {
		/** @type {Customers_Permits_Properties} properties */
		let properties = this.model.properties;
		/** @type {Customers_Permits_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<h4 className="section-title">NICS Exception Permit
					</h4>
					<div className="form-group" data-id="customer-id-state">
						<Framework.Elements.Select
							shouldLoad={this.state.loaded}
							update={this.handleSelectPropertyUpdate}
							property={properties.state}
							value={object.state}
							error={object.state_error}
							id={'short'}
							model={Types.States._name}
							nullable={false}
							limit={null}
							label={"Permit State"}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.type}
							value={object.type}
							error={object.type_error}
							update={this.handleTextFieldPropertyUpdate}
							label={"Permit Type"}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.Date
							label={"Permit Issue Date"}
							property={properties.issue}
							value={object.issue}
							error={object.issue_error}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.Date
							label={"Permit Expiration Date"}
							property={properties.expiration}
							value={object.expiration}
							error={object.expiration_error}
							update={this.handleTextFieldPropertyUpdate}
						/>
					</div>
					<div className="form-group">
						<Framework.Elements.TextField
							property={properties.number}
							value={object.number}
							error={object.number_error}
							update={this.handleTextFieldPropertyUpdate}
							label={"Permit Number"}
							data-id={"permit-number"}
							id={"permit_number"}
						/>
					</div>
					{/*#region Front Image Upload*/}
					<h4 className="section-title">Permit Image Upload</h4>
					<div className="form-group">
						<h6>Upload a copy of the permit for future reference and verification. Files must be .png, .jpg, or .jpeg. Max file size is 4MB. <b>After you finish uploading, click Save.</b></h6>
						<p>Image Front</p>
						<Framework.Elements.DropZone
							property={properties.image}
							value={object.image}
							error={object.image_error}
							update={this.handleFileChange}
							label={'Drag \'n\' drop front image here, or click to select image'}
						/>
						<br/>
						{object.image && <div>
							<p style={{display: "inline"}}>Current Front Image</p>
							<Button className="image_remove_button" color="warning" onClick={() => this.handleDeleteImage('image')}>Remove
								Image</Button>
							<img
								src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + object.customer_binary_id + '-' + object.customer + '/permits/' + object.binary_id + '-' + object.pkey + '/images?image=' + object.image}
								alt={object.image}
								className='image_upload_images'
							/>
							{object.image ?
								<span>Current Image - <b>{object.image}</b></span>
								: null}
						</div>}
						<br/>
						<p>Image Back</p>
						<Framework.Elements.DropZone
							property={properties.image_back}
							value={object.image_back}
							error={object.image_back_error}
							update={this.handleFileChange}
							label={'Drag \'n\' drop back image here, or click to select image'}
						/>
						<br/>
						{object.image_back && <div>
							<p style={{display: "inline"}}>Current Back Image</p>
							<Button className="image_remove_button" color="warning" onClick={() => this.handleDeleteImage('image_back')}>Remove
								Image</Button>
							<img
								src={APPCONFIG.settings.apiURL() + '/' + APPCONFIG.settings.apiVersion + '/customers/' + object.customer_binary_id + '-' + object.customer + '/permits/' + object.binary_id + '-' + object.pkey + '/images/back?image=' + object.image_back}
								alt={object.image_back}
								className='image_upload_images'
							/>
							{object.image_back ?
								<span>Current Image - <b>{object.image_back}</b></span>
								: null}
						</div>}
					</div>
					{/*#endregion*/}
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};
}


export default Framework.Components.withRootState(CustomerNicsPermit);

